webpackJsonp([23221215298982],{

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/culture.0df151c2.jpg";

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/groceries.7dcb1e0d.jpg";

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iceCaves.9b7d35cd.jpg";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nature.55a3ea06.jpg";

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    title: 'Omgeving',
	    natureTitle: 'Natuur',
	    natureP1: 'Het huis ligt midden in een “Naturschutzgebiet”, aan de rand van de Vulkaan-Eifel. Tot op heden zijn nog altijd elementen van de oude vulkanische activiteiten terug te zien. Her en der kan je oude vulkanen herkennen in de diverse vergezichten. Er is in het plaatsje Wallenborn (op slechts 16 km van Kopp) zelfs nog een geiser te bezichtigen. Dit is een zogenaamde koudwatergeiser, en werkt als een soort cola-fles die je flink schudt voordat je hem open maakt. Ter geruststelling, de oude vulkanen zijn niet meer actief.',
	    iceCavesTitle: 'IJsgrotten',
	    iceCavesP1: 'In de omgeving heb je op slechts een paar kilometer van het huis verschillende “Eishöhlen”. De ijs- of molensteengrotten zijn ondergrondse steengroeven waar tot in de 19e eeuw de molenstenen werden uitgehouwen voor het malen van eikenschors (zelden voor het malen van meel). De grotten zijn waarschijnlijk al vele honderden jaren bekend. Er zijn 5 grotten, die deels met elkaar verbonden zijn. Er heerst het hele jaar een temperatuur van rond het vriespunt (-1 tot 6 graden). De tot diep in de berg reikende grotten danken hun naam aan het verschijnsel dat zich in een strenge winter ijspegels vormen aan het plafond en op de bodem. Deze ijspegels kunnen tot in de zomer behouden blijven. De wandeling naar de grotten vanuit het huis is een aanrader.',
	    iceCavesP2: 'Met de auto kan men vanuit Birresborn tot vlak bij de grotten komen. Als u de in de grotten aanwezige molenstenen aan de muren wilt zien, is het raadzaam een beschermend hoofddeksel (liefst een helm) te dragen. En neem in elk geval een zaklamp mee. Tijdens de wintermaanden zijn de meeste grotten gesloten omdat ze als winterslaapplaats dienen voor vleermuizen.',
	    cultureTitle: 'Cultuur',
	    cultureP1: 'In de directe omgeving liggen verschillende bezienswaardige plaatsjes. Om te beginnen natuurlijk Gerolstein (het Spa van de Eifel). Niet veel verder ligt Prüm met zijn St.Salvator Basiliek. Ook Kyllburg, Blankenheim en Adenau zijn een bezoekje waard.',
	    cultureP2: 'Ook staan er diverse kastelen. Zo kennen we Kasselburg met zijn adelaars- en wolvenpark, Burg Lissingen, Bertadaburg Mürlenbach en Schloss Malmberg. En natuurlijk zijn er verschillende ruines. De meest bekende in de buurt zijn Burgruine Löwenburg (hoog boven Gerolstein, met een fraai uitzicht over de stad) en Burgruine Freudenkoppe op de vulkaankegel "Nerother Kopf".',
	    cultureP3: 'Wil je natuur met cultuur combineren dan kan je vanuit het huis een wandeling maken naar het kunstenaarsdorp Weißenseifen. De weg tegenover het huis naar beneden lopen en daar de borden volgen (ongeveer 4 km).',
	    groceriesTitle: 'Winkels',
	    groceriesP1: 'In Kopp zelf zijn geen winkels. Broodjes kan je halen in Birresborn (4 km) en voor de grotere winkels moet je in Prüm zijn (16km) of naar Gerolstein rijden (11km) waar ook het toeristenbureau te vinden is in het treinstation.'
	  },
	  de: {
	    title: 'Die Umgebung',
	    natureTitle: 'Natur',
	    natureP1: 'Das Haus liegt in einem “Naturschutzgebiet”, und befindet sich am Rande des Vulkaneifels. Bis heute finden Sie noch Elemente der alten vulkanischen Aktivitäten. Hier und da erkennt man die alte Vulkane in den verschiedenen Ansichten. Es gibt in der Stadt Wallenborn (nur 16 km von Kopp), sogar einen Geysir. Dies nennt man einen Kaltwasser-Geysir, und wirkt wie eine Cola-Flasche, die Sie schütteln, bevor Sie es öffenen. Zür Beruhigung, die ehemaligen Vulkane sind nicht mehr aktiv.',
	    iceCavesTitle: 'Eishöhlen',
	    iceCavesP1: 'In der Umgebung sind nur wenige Kilometer erweitert von dem Haus mehrere “Eishöhlen”. Die Eis- oder Mühlstein Höhlen sind unterirdischen Steinbrüchen, wo bis zum 19. Jahrhundert, die Mühlsteine geschnitzt wurden, um Eichenrinde zu schleifen. (selten für das Schleifen von Mehl). Die Höhlen sind wohl seit vielen Hunderten Jahren bekannt. Es gibt 5 Höhlen, die teilweise miteinander verbunden sind. Es gibt ein ganzjährige Temperatur um den Gefrierpunkt (-1 bis 6 Grad). Ihren Namen verdanken diese tief in den Berg hineinreichenden Höhlen dem Phänomen, dass sich dort nach einem strengen Winter die Eiszapfen, welche sich an der Decke und auf dem Boden gebildet haben, bis zum Sommer hinein halten. Die Wanderung zu den Höhlen aus dem Haus ist ein Muss.',
	    iceCavesP2: 'Mit dem Auto können Sie die Höhlen auch erreichen von Birresborn. Falls Sie die Höhlen und noch vorhandene Mühlsteine an Decken und Wänden betrachten wollen, ist es ratsam eine schützende Kopfbedeckung (am besten einen Helm) zu tragen. Und in jedem Fall nehmen Sie eine Taschenlampe mit. In den Wintermonaten sind die meisten Höhlen geschlossen, weil sie als Überwinterungsplatz für Fledermäuse dienen.',
	    cultureTitle: 'Cultuur',
	    cultureP1: 'In unmittelbarer Nähe befinden sich mehrere sehenswerte Orte. Zu beginnen natürlich, Gerolstein. Nicht viel weiter entfernt liegt Prüm mit seiner St.SalvatorBasilika. Auch Kyllburg, Blankenheim und Adenau sind ein Besuch wert.',
	    cultureP2: 'Es gibt auch mehrere Schlösser. So ist da Kasselburg mit seinem Adler- und Wolfspark, Burg Lissingen, Bertadaburg Mürlenbach und Schloss Malmberg. Es gibtnatürlich auch einige Ruinen. Die bekanntesten in der Region sind Burgruine Löwenburg (hoch über Gerolstein, mit einem schönen Blick über die Stadt) undBurgruine Freudenkoppe auf der Vulkankegel Nerother Kopf.',
	    cultureP3: 'Möchten Sie die Natur kombinieren mit Kultur, dan können Sie von Haus direkt einen Spaziergang machen nach dem Künstlerdorf Weißenseifen. Die Straße vor dem Haus heruntergehen und dort folgen Sie der Beschilderung (ca. 4 km).',
	    groceriesTitle: 'Einkaufen',
	    groceriesP1: 'In Kopp selbst sind keine Geschäfte. Brötchen können Sie in Birresborn (4 km) beim Bäcker kaufen. Für größere Geschäfte konnen Sie nach Gerolstein gehen (11 km), oder Sie fahren nach Prüm (16 km). Die Touristeninformation befindet sich im Bahnhofsgebäude in Gerolstein.'
	  },
	  en: {
	    title: 'Surroundings',
	    natureTitle: 'Nature',
	    natureP1: 'The house is located in the middle of a "Naturschutzgebiet", on the edge of the Vulkan-Eifel. Elements of the old volcanic activities can still be seen today and you can recognize old volcanoes in the various vistas. There is even a geyser in the town of Wallenborn (only 16 km from Kopp). This is a so-called cold water geyser, and works like shaken fizzy drink bottle. For reassurance, the old volcanoes are no longer active.',
	    iceCavesTitle: 'Ice caves',
	    iceCavesP1: 'There are several "Eishölen" just a few kilometers from the house. The ice/millstone caves are underground quarries where, until the 19th century, millstones used for grinding oak bark (rarely for grinding flour) were won. The existance of these caves has probably been known for hundreds of years. There are 5 caves that are partly connected to each other. The temperature is around freezing point throughout the year (-1 to 6 degrees). The caves that reach deep into the mountain owe their name to the phenomenon that in a severe winter icicles form on the ceilings and floors. Due to the cold, these icicles can even last through summer. The walk to the caves from the house is very beautiful and something you should not skip whilst here.',
	    iceCavesP2: 'You can get very close to the caves if you come by car from Birresborn. If you want to go and see the millstones in the caves, it is advisable to wear some protective headgear (preferably a helmet), and at the very least to bring a torch. During the winter, most caves are closed because they serve as a hibernation place for bats',
	    cultureTitle: 'Culture',
	    cultureP1: 'There are several places of interest in the immediate vicinity. Of course there is Gerolstein (the Spa of the Eifel). Not far past Gerolstein lays Prüm with its St.Salvator Basilica. The places Kyllburg, Blankenheim and Adenau are also worth a visit.',
	    cultureP2: 'You will also find several castles nearby. There is Kasselburg with its Eagle and Wolf park, Burg Lissingen, Bertadaburg Mürlenbach and Schloss Malmberg. In addition there are also several ruins nearby, the most famous of which are Burgruine Löwenburg (high above Gerolstein with a beatiful view of the city) and Burgruine Freudekoppe on the volcanic cone "Nerother Kopf".',
	    cultureP3: 'If you want to combine nature with culture, you can walk from the house to the artistic village of Weißenseifen. Walk down the road opposite the house and follow the signs (about 4 km).',
	    groceriesTitle: 'Groceries',
	    groceriesP1: 'You won\'t find any stores in Kopp itself. You can get bread and lunch items in Birresborn (4 km). For larger stores you will have to go to Prüm (16 km) or to Gerolstein (11 km) where you will also find the tourist office in the train station.'
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContentBlock = __webpack_require__(10);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _surroundings = __webpack_require__(199);
	
	var _surroundings2 = _interopRequireDefault(_surroundings);
	
	var _nature = __webpack_require__(417);
	
	var _nature2 = _interopRequireDefault(_nature);
	
	var _iceCaves = __webpack_require__(416);
	
	var _iceCaves2 = _interopRequireDefault(_iceCaves);
	
	var _culture = __webpack_require__(414);
	
	var _culture2 = _interopRequireDefault(_culture);
	
	var _groceries = __webpack_require__(415);
	
	var _groceries2 = _interopRequireDefault(_groceries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurroundingsPage = function SurroundingsPage(props) {
	  var language = props.language;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { darkBackground: true },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-heading-xl' },
	        _surroundings2.default[language].title
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _surroundings2.default[language].natureTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].natureP1
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _nature2.default + ')' } })
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true, reverse: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _surroundings2.default[language].iceCavesTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].iceCavesP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].iceCavesP2
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _iceCaves2.default + ')' } })
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _surroundings2.default[language].cultureTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].cultureP1
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].cultureP2
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].cultureP3
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _culture2.default + ')' } })
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { split: true, reverse: true, darkBackground: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 't-heading-s' },
	          _surroundings2.default[language].groceriesTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _surroundings2.default[language].groceriesP1
	        )
	      ),
	      _react2.default.createElement('div', { style: { backgroundImage: 'url(' + _groceries2.default + ')' } })
	    )
	  );
	};
	
	SurroundingsPage.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = SurroundingsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-surroundings-js-24ec8c1aaf868fe4b0d5.js